import { useTranslation } from 'react-i18next';
import HCaptcha from '@hcaptcha/react-hcaptcha';

import UI from '../../common/UI';
import config from '../config';
import useLocale from '../../common/useLocale';

export interface TurnstileProps {
  onSuccess: (token: string) => void;
}

const Turnstile = ({ onSuccess }: TurnstileProps) => {
  const { t } = useTranslation();
  const { locale } = useLocale();

  return (
    <UI.FlexContainer
      sc={{ alignItems: 'center', justifyContent: 'center', direction: 'column' }}
      style={{ minHeight: '100%' }}
    >
      <UI.Legend sc={{ textAlign: 'center', mb: 3 }}>
        {t('common:validation.verifying_human')}
      </UI.Legend>
      <HCaptcha
        sitekey={config.hcaptchaSiteKey}
        languageOverride={locale}
        onVerify={onSuccess}
      />
    </UI.FlexContainer>
  );
};

export default Turnstile;
